import React, { useEffect, useRef } from "react";
import classes from './Project.module.css'
import * as ideWrapper from "../../lms-shared/ide-wrapper";

const Project = ({ attachmentUrl, ideUrl, ideConfig, height, IdeLang }) => {

    const iframeRef = useRef();

    useEffect(() => {
        ideUrl && ideWrapper.load(attachmentUrl, iframeRef.current, ideUrl, ideConfig, IdeLang)
    }, [attachmentUrl, ideUrl])

    return <div className={classes.ProjectContainer}>
        {/* <div style={{ backgroundColor: "red" }}><button onClick={ideWrapper.requestSaveProject}>save</button></div> */}
        <iframe style={{ width: '98vw', height: height ? height : "calc(100vh - 80px)", position: "absolute", bottom: "0", right: "2vw" }} ref={iframeRef} title='bla' frameBorder={0}></iframe>
    </div>
};

export default Project;